<template>
  <header class="app-header">
    <div class="header-actions">
      <div class="balance-pill" aria-hidden="true">
        <img class="asset-ico" :src="sliceUrl('asset.png')" alt="" />
      </div>

      <div ref="profileWrap" class="profile-wrap">
        <button type="button" class="avatar-btn" @click="toggleMenu">
          <el-avatar
            class="avatar"
            size="medium"
            src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
          />
        </button>

        <transition name="head-menu-fade">
          <div v-if="menuOpen" class="head-menu">
            <button type="button" class="head-menu-item" @click="openPwdDialog">
              <img :src="sliceUrl('head_change_pwd.png')" alt="" />
              <span>修改密码</span>
            </button>
            <button type="button" class="head-menu-item head-menu-item--danger" @click="logout">
              <img :src="sliceUrl('head_login_out.png')" alt="" />
              <span>退出登录</span>
            </button>
          </div>
        </transition>
      </div>
    </div>

    <el-dialog
      :visible.sync="pwdVisible"
      width="480px"
      custom-class="cp-dialog merchant-create-dlg pwd-change-dlg"
      append-to-body
      :close-on-click-modal="false"
      @closed="resetPwdForm"
    >
      <div slot="title" class="create-title">
        <div>
          <div class="t1">修改登录密码</div>
          <div class="t2">修改成功后请使用新密码登录；须验证谷歌验证器动态码</div>
        </div>
      </div>
      <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-position="top" class="create-form">
        <el-form-item label="新登录密码" prop="new_password">
          <el-input
            v-model="pwdForm.new_password"
            :type="showNewPwd ? 'text' : 'password'"
            placeholder="至少 6 位"
            autocomplete="new-password"
          >
            <template slot="suffix">
              <button type="button" class="pwd-toggle" @click="showNewPwd = !showNewPwd">
                <img :src="bizIcon(showNewPwd ? 'close_eyes.png' : 'eyes.png')" alt="" />
              </button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirm_password">
          <el-input
            v-model="pwdForm.confirm_password"
            :type="showConfirmPwd ? 'text' : 'password'"
            placeholder="再次输入新密码"
            autocomplete="new-password"
            @keyup.enter.native="submitPwd"
          >
            <template slot="suffix">
              <button type="button" class="pwd-toggle" @click="showConfirmPwd = !showConfirmPwd">
                <img :src="bizIcon(showConfirmPwd ? 'close_eyes.png' : 'eyes.png')" alt="" />
              </button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="谷歌验证器" prop="totp_code">
          <el-input
            v-model="pwdForm.totp_code"
            maxlength="8"
            placeholder="6 位动态码"
            autocomplete="one-time-code"
            @keyup.enter.native="submitPwd"
          />
        </el-form-item>
      </el-form>
      <el-button type="primary" class="btn-gradient full-create" :loading="pwdSaving" @click="submitPwd">
        <span class="full-create-content">
          <img class="add-ico" :src="bizIcon('operate.png')" alt="" />
          <span class="full-create-text">保存修改</span>
        </span>
      </el-button>
    </el-dialog>
  </header>
</template>

<script>
import { merchantApi } from '@/api/merchant'

export default {
  name: 'AppHeader',
  data() {
    const confirmRule = (rule, value, cb) => {
      if (value !== this.pwdForm.new_password) {
        cb(new Error('两次输入的新密码不一致'))
        return
      }
      cb()
    }
    return {
      menuOpen: false,
      pwdVisible: false,
      pwdSaving: false,
      showNewPwd: false,
      showConfirmPwd: false,
      pwdForm: {
        new_password: '',
        confirm_password: '',
        totp_code: ''
      },
      pwdRules: {
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          {
            validator(rule, value, cb) {
              if (String(value).length < 6) return cb(new Error('密码至少 6 位'))
              cb()
            },
            trigger: 'blur'
          }
        ],
        confirm_password: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: confirmRule, trigger: 'blur' }
        ],
        totp_code: [{ required: true, message: '请输入谷歌验证器动态码', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.onDocClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick)
  },
  methods: {
    sliceUrl(name) {
      return `${process.env.BASE_URL}slices/${name}`
    },
    bizIcon(name) {
      return `${process.env.BASE_URL}slices/business/${name}`
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    onDocClick(e) {
      if (!this.menuOpen) return
      const wrap = this.$refs.profileWrap
      if (wrap && !wrap.contains(e.target)) {
        this.menuOpen = false
      }
    },
    openPwdDialog() {
      this.menuOpen = false
      this.pwdVisible = true
    },
    resetPwdForm() {
      this.pwdForm = {
        new_password: '',
        confirm_password: '',
        totp_code: ''
      }
      this.showNewPwd = false
      this.showConfirmPwd = false
      this.$nextTick(() => {
        if (this.$refs.pwdForm) this.$refs.pwdForm.clearValidate()
      })
    },
    submitPwd() {
      this.$refs.pwdForm.validate(async (ok) => {
        if (!ok) return
        this.pwdSaving = true
        try {
          await merchantApi.changePassword({
            new_password: this.pwdForm.new_password,
            totp_code: this.pwdForm.totp_code.replace(/\s/g, '')
          })
          this.$message.success('密码已修改，请重新登录')
          this.pwdVisible = false
          sessionStorage.removeItem('cryptopay_token')
          this.$router.replace('/login')
        } catch (e) {
          /* 错误由 request 拦截器统一提示 */
        } finally {
          this.pwdSaving = false
        }
      })
    },
    logout() {
      this.menuOpen = false
      sessionStorage.removeItem('cryptopay_token')
      this.$router.replace('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 28px;
  flex-shrink: 0;
  background: #171b32;
  border-bottom: none;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.balance-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 10px;
  border-radius: 999px;
  background: rgba(22, 26, 44, 0.95);
  border: 1px solid rgba(55, 65, 90, 0.5);
}

.asset-ico {
  width: 26px;
  height: 26px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}

.profile-wrap {
  position: relative;
}

.avatar-btn {
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
}

.avatar {
  border: 2px solid rgba(124, 58, 237, 0.45);
  display: block;
}

.head-menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 168px;
  padding: 8px;
  border-radius: 12px;
  background: rgba(17, 22, 43, 0.98);
  border: 1px solid rgba(55, 65, 90, 0.45);
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.45);
  z-index: 200;
}

.head-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #e8eaef;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s;

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }

  &--danger {
    color: #f87171;

    &:hover {
      background: rgba(248, 113, 113, 0.08);
    }
  }
}

.head-menu-fade-enter-active,
.head-menu-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.head-menu-fade-enter,
.head-menu-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.create-title .t1 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.create-title .t2 {
  font-size: 13px;
  color: #8b92a8;
  margin-top: 4px;
  line-height: 1.45;
}

.pwd-toggle {
  padding: 0 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;

  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
    display: block;
    opacity: 0.95;
  }
}

.full-create {
  width: 100%;
  margin-top: 4px;
}

.full-create-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.add-ico {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.btn-gradient {
  background: linear-gradient(90deg, #5b45ff, #a855f7) !important;
  border: none !important;
  color: #fff !important;
}
</style>

<style lang="scss">
.pwd-change-dlg.merchant-create-dlg {
  background: #11162b !important;
  border: none !important;
  border-top: 1px solid rgba(67, 70, 86, 0.05) !important;
  border-radius: 14px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5) !important;

  .el-dialog__header {
    padding: 20px 22px 0;
  }

  .el-dialog__body {
    padding: 12px 22px 22px;
    background: transparent !important;
  }

  .el-dialog__headerbtn {
    top: 18px;
    right: 16px;

    .el-dialog__close {
      color: #8b92a8;
      font-size: 18px;
    }
  }

  .el-form-item__label {
    color: #a8b0c4 !important;
  }

  .el-input__inner {
    height: 36px;
    line-height: 36px;
    background: #0f1324 !important;
    border: 1px solid rgba(99, 71, 255, 0.22) !important;
    color: #e8eaef !important;
  }

  .el-input__inner::placeholder {
    color: #6f7b96 !important;
  }
}
</style>
